import { render } from "./AiSqlGenerator.vue?vue&type=template&id=ef7d4b9a"
import script from "./AiSqlGenerator.vue?vue&type=script&lang=js"
export * from "./AiSqlGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__